import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

const { colors, spacing, typography } = themeVariables;

export const imageNumberLabel = css`
  background-color: var(${colors.surface.default});
  border-radius: 10px;
  padding: 0 var(${spacing.sm});
  margin: 0;
  font-size: var(${typography.body.sizes.md.fontSize});
  line-height: var(${typography.body.sizes.md.lineHeight});
  letter-spacing: var(${typography.body.letterSpacing});
  font-weight: 700;
`;
